import data from "../../.sourceflow/job_type.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const job_type_helper = new CollectionHelper(data);
